import React, { Component } from 'react';
import noop from 'lodash/noop';
import { Controlled } from 'react-codemirror2';

import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import './codeMirrorModes';

const defaultOptions = {
  theme: 'material',
  lineNumbers: true,
  lineWrapping: true
};

class CodeMirror extends Component {
  static defaultProps = {
    editorDidMount: noop
  };

  render() {
    const { value, onChange, options, mode = 'javascript', editorDidMount, className } = this.props;

    return (
      <Controlled
        className={className}
        options={{ ...defaultOptions, ...options, mode }}
        value={value}
        onBeforeChange={onChange}
        editorDidMount={editorDidMount}
      />
    );
  }
}

export default CodeMirror;
